import api from "./client";
import { clearStoredUser } from "../utils/session";

export async function login(
  email,
  password,
  mfaCode = "",
  facilityCode = "",
  recoveryCode = ""
) {
  const payload = {
    email,
    password,
  };

  if (facilityCode) {
    payload.facility_code = facilityCode;
  }

  if (mfaCode) {
    payload.mfa_code = mfaCode;
  }

  if (recoveryCode) {
    payload.recovery_code = recoveryCode;
  }

  const res = await api.post("/login", payload);
  return res.data;
}

export async function logout() {
  try {
    await api.post("/logout");
  } finally {
    clearStoredUser();
  }
}
export function forgotPassword(email) {
  return api.post("/forgot-password", { email });
}

export function resetPassword(email, token, password, passwordConfirmation) {
  return api.post("/reset-password", {
    email,
    token,
    password,
    password_confirmation: passwordConfirmation,
  });
}
export function completePasswordReset(password, passwordConfirmation) {
  return api.post("/password/complete-reset", {
    password,
    password_confirmation: passwordConfirmation,
  });
}

export function requestInmateAccessReset(facilityCode, inmateNumber) {
  return api.post("/inmate/forgot-access", {
    facility_code: facilityCode,
    inmate_number: inmateNumber,
  });
}
